/* ------------------------------------------------------------------------------
@name: Components Index
@description: Indexing all components
--------------------------------------------------------------------------------- */

import InputDropdown from "./InputDropdown";
import Reseller from "./Reseller";
import Customer from "./Customer";
import Order from "./Order";
import Dashboard from "./Dashboard";
import User from "./User";
import Role from "./Role";
import Gallery from "./Gallery";
import SelectData from "./SelectData";
import Product from "./Product";

export {
  Reseller,
  Customer,
  Order,
  InputDropdown,
  Dashboard,
  User,
  Role,
  Gallery,
  SelectData,
  Product,
};
